import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { IntListRequest } from "./IntListRequest";

@Injectable()
export class DataService_ScanStationRebuildSU {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	FacilitySelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GetSchoolFacilities?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilitySchoolSelectList(FacilityID, Active) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GetFacilitySchool?FacilityID=" + FacilityID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationRebuildSelectList(SchoolID, FacilityID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationRebuildSelectList?SchoolID=" + SchoolID + "&FacilityID=" + FacilityID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationRebuildMultiple(parms: IntListRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationRebuildMultiple";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
